<app-header *ngIf="!isEmbeddedSearchDetails"></app-header>
<alert *ngIf="!isEmbeddedSearchDetails"></alert>
<app-confirm-dialog *ngIf="!isEmbeddedSearchDetails"></app-confirm-dialog>
<loader></loader>
<router-outlet></router-outlet>
<app-footer *ngIf="!isEmbeddedSearchDetails"></app-footer>